export default "__VITE_ASSET__DtUkU$RI__"